
import React from 'react';
import { motion } from 'framer-motion';
import { FaPalette, FaGamepad, FaEnvelope, FaDiscord, FaDownload, FaSteam, FaYoutube, FaFile } from 'react-icons/fa';

import '../pages/Presskit.css';
import Footer from '../components/Footer';
import { Header } from '../components/header';
import { useEffect } from 'react';

function Presskit() {
  useEffect(() => {
    document.title = "Press Kit | RedCoris Indie Game Studio";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Access the official RedCoris Press Kit. Media resources, key art, and info for Echoes of Sin: Confusion and our game studio.");
    }
  }, []);

  const documents = [
    /* {
       id: 1,
       name: 'Company Overview',
       description: 'Complete information about RedCoris , our vision, and project background',
       fileName: 'https://drive.google.com/uc?export=download&id=1l5tOPQWS2atGGOvdjdUaNcLouFmoJQ-u',
       type: 'PDF',
       icon: <FaBuilding />
     },
     {
       id: 2,
       name: 'Brand Assets',
       description: 'Official logos, brand guidelines, and visual identity materials',
       fileName: 'redcoris-brand-assets.zip',
       type: 'ZIP',
       icon: <FaPalette />
     },
     {
       id: 3,
       name: 'Game Presskit',
       description: 'High-resolution screenshots, gameplay footage, and game information',
       fileName: 'echoes-of-sin-presskit.zip',
       type: 'ZIP',
       icon: <FaGamepad />
     },*/

    {
      id: 1,
      name: 'Key Art & Logos',
      description: 'Key art and logos for Echoes of Sin',
      fileName: 'https://drive.google.com/uc?export=download&id=1L9upeECquBUlRmq7cpAClphp3G6ITy1F',
      type: 'ZIP',
      icon: <FaPalette />
    },

    {
      id: 2,
      name: 'Screenshots & Gameplay',
      description: 'Screenshots and gameplay for Echoes of Sin',
      fileName: 'https://drive.google.com/uc?export=download&id=1h4n2_DA2JQMQyi4q5Vn5Di8MKwHvgTly',
      type: 'ZIP',
      icon: <FaGamepad />
    },

    {
      id: 3,
      name: 'Steam Assets',
      description: 'Steam assets for Echoes of Sin',
      fileName: 'https://drive.google.com/uc?export=download&id=1CBoF3VvA3jApbtbxVYfHReb8MsL2jay-',
      type: 'ZIP',
      icon: <FaSteam />
    },

    {
      id: 4,
      name: 'Trailer Videos',
      description: 'Trailer videos for Echoes of Sin',
      fileName: 'https://drive.google.com/uc?export=download&id=1CV2zWpMQfXs2VBPcrwXAkduqLplGx9Vn',
      type: 'ZIP',
      icon: <FaYoutube />
    },

    {
      id: 5,
      name: 'Basic Information',
      description: 'Basic information for Echoes of Sin',
      fileName: 'https://drive.google.com/uc?export=download&id=19pO6e8j57jVdcVzwZzr0kscTBVtdC49K',
      type: 'PDF',
      icon: <FaFile />
    },
  ];

  const handleDownload = (fileName) => {
    console.log(`Downloading: ${fileName}`);
    //alert(`File ${fileName} is ready for download.\n\nIn production, this would trigger the actual file download.`);
    window.location.href = fileName;
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  return (
    <div className="presskit-page">
      <Header />

      <section className="presskit-hero">
        <div className="presskit-hero-content">
          <motion.h1
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Press Kit
          </motion.h1>
          <motion.p
            className="presskit-tagline"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Resources for journalists, media partners, and industry professionals
          </motion.p>
        </div>
      </section>

      <div className="presskit-content-wrapper">
        <div className="presskit-container">
          <motion.div
            className="presskit-intro"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>About Red Coris</h2>
            <p>
              Red Coris is an independent game development studio dedicated to creating immersive,
              psychologically engaging experiences. Our team combines artistic vision with technical excellence
              to deliver innovative gaming experiences that captivate audiences worldwide.
            </p>
          </motion.div>

          {/* <motion.div
            className="presskit-highlights"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.div className="highlight-item" variants={itemVariants}>
              <h3>🎯 Our Mission</h3>
              <p>Create memorable gaming experiences that push creative boundaries</p>
            </motion.div>
            <motion.div className="highlight-item" variants={itemVariants}>
              <h3>🌍 Global Reach</h3>
              <p>Building a community of players across multiple continents</p>
            </motion.div>
            <motion.div className="highlight-item" variants={itemVariants}>
              <h3>🚀 Innovation</h3>
              <p>Leveraging cutting-edge technology for immersive gameplay</p>
            </motion.div>
          </motion.div>
*/}
          <motion.div
            className="presskit-usage bento-style"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="usage-header">
              <FaFile className="usage-icon" />
              <h2>Press Kit Usage</h2>
            </div>
            <div className="usage-content">
              <p className="usage-main-text">
                All images and video materials in this press kit may be freely used for content creation,
                articles, thumbnails, videos, and promotional coverage of the game <strong>Echoes of Sin: Confusion</strong>.
              </p>

              <div className="usage-rules">
                <h3>You are welcome to:</h3>
                <ul>
                  <li>– crop images</li>
                  <li>– add your own text or thumbnails</li>
                  <li>– adjust colors</li>
                  <li>– edit for video or social media</li>
                  <li>– use them in monetized content</li>
                </ul>
              </div>

              <p className="usage-permission">No additional permission is required.</p>

              <div className="usage-footer">
                <p>If possible, please include a link to the <a href="https://store.steampowered.com/app/4426280/" target="_blank" rel="noopener noreferrer" className="steam-inline-link">Steam page</a>.</p>
                <p className="usage-thank-you">Thank you for covering the game.<br /><strong>REDcoris.</strong></p>
              </div>
            </div>
          </motion.div>

          <div className="presskit-section">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2>Media Resources</h2>
              <p className="section-description">
                Download our complete media package containing all materials needed for coverage and promotion
              </p>
            </motion.div>

            <motion.div
              className="documents-grid"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {documents.map((doc) => (
                <motion.div key={doc.id} className="document-card bento-style" variants={itemVariants}>
                  <div className="document-icon-wrapper">
                    {doc.icon}
                  </div>
                  <div className="document-content">
                    <h3>{doc.name}</h3>
                    <p>{doc.description}</p>
                    <div className="document-footer">
                      <span className="doc-type">{doc.type}</span>
                      <button
                        className="download-button"
                        onClick={() => handleDownload(doc.fileName)}
                      >
                        <FaDownload size={14} style={{ marginRight: '8px' }} /> Download
                      </button>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          <motion.div
            className="presskit-contact bento-style"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>Get in Touch</h2>
            <div className="contact-info">
              <p>
                For media inquiries, partnership opportunities, or additional resources, please reach out to our press team.
              </p>
              <div className="contact-methods">
                <a href="mailto:business@redcoris.com" className="contact-link">
                  <FaEnvelope /> business@redcoris.com
                </a>
                <a href="https://discord.com/invite/GDhzHFa8VX" target="_blank" rel="noopener noreferrer" className="contact-link">
                  <FaDiscord /> Join Our Discord
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Presskit;
